export class URLManager {
  constructor(config = {}) {
    this.config = {
      paramName: 'search',
      enabled: true,
      ...config
    };
    
    this.currentQuery = '';
  }

  init() {
    if (!this.config.enabled) return null;
    
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get(this.config.paramName);
    
    if (searchQuery) {
      this.currentQuery = searchQuery;
      return searchQuery;
    }
    
    return null;
  }

  updateURL(searchQuery) {
    if (!this.config.enabled) return;
    
    const url = new URL(window.location);
    
    if (searchQuery && searchQuery.trim().length > 0) {
      url.searchParams.set(this.config.paramName, searchQuery);
      this.currentQuery = searchQuery;
    } else {
      url.searchParams.delete(this.config.paramName);
      this.currentQuery = '';
    }
    
    window.history.replaceState({}, '', url.toString());
  }

  getShareableURL(searchQuery = null) {
    const url = new URL(window.location);
    
    if (searchQuery || this.currentQuery) {
      url.searchParams.set(this.config.paramName, searchQuery || this.currentQuery);
    }
    
    return url.toString();
  }

  attachPopStateListener(callback) {
    const handlePopState = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get(this.config.paramName);
      
      if (searchQuery !== this.currentQuery) {
        this.currentQuery = searchQuery || '';
        callback(this.currentQuery);
      }
    };
    
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }

  parseCustomParams(listElement) {
    const urlParamAttr = listElement.getAttribute('pixl-url-param-name');
    if (urlParamAttr) {
      this.config.paramName = urlParamAttr;
    }
    
    const urlEnabled = listElement.getAttribute('pixl-url-params');
    if (urlEnabled !== null) {
      this.config.enabled = urlEnabled === 'true';
    }
  }

  clearURL() {
    if (!this.config.enabled) return;
    
    const url = new URL(window.location);
    url.searchParams.delete(this.config.paramName);
    window.history.replaceState({}, '', url.toString());
    this.currentQuery = '';
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  setParamName(name) {
    this.config.paramName = name;
  }

  enable() {
    this.config.enabled = true;
  }

  disable() {
    this.config.enabled = false;
    this.clearURL();
  }
}